import { render, staticRenderFns } from "./PedidosRealizados.vue?vue&type=template&id=4e33a65a"
import script from "./PedidosRealizados.vue?vue&type=script&lang=ts"
export * from "./PedidosRealizados.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports